<template>
  <div class="jobRow row wrap justify-space align-center">
    <div class="grid-10 row wrap">
      <div class="ticket grid-2 grid-6-s">{{ job.id }}</div>
      <div class="grid-3 grid-6-s">
        {{ new Date(job.dh_atendimento).toLocaleDateString() }}
      </div>
      <div class="grid-4 grid-6-s">
        {{ job.status.replace("Doutor", "Supporter") }}
      </div>
      <div class="grid-1 grid-6-s">
        <JobStatus :color="job.sla_vencido === 'sim' ? 'red' : 'green'" />
      </div>
    </div>
    <div class="grid-2 grid-2-s justify-end row">
      <Button layout="purple" @click="openJob()">ABRIR</Button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Button from "@/components/Button";
import JobStatus from "@/components/JobStatus";

export default {
  name: "jobRow",
  props: {
    job: Object,
  },
  components: { Button, JobStatus },
  data() {
    return {};
  },
  methods: {
    ...mapMutations("job", ["SET_JOB"]),
    openJob() {
      this.SET_JOB(this.job);
      this.$router.push(`/job/${this.job.id}`);
    },
  }
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;
.jobRow {
  padding: 17px 33px;
  color: $font-color;
  font-size: 14px;

  @media (max-width: $small) {
    padding: 19px;
    font-size: 0.8rem;
  }

  .ticket {
    font-weight: 500;
    text-decoration: underline;

    @media (max-width: $small) {
      margin-bottom: 10px;
    }
  }
}
</style>
